import React from 'react';
import {Field} from 'redux-form';
import {Form, Row, Col} from 'react-bootstrap';
import {Button} from '@material-ui/core';
import {isEmpty} from 'lodash/lang';
import * as fields from 'components/common/fields';
import {makeForm, getReaderAvatarOptions} from 'utils/common';
import * as validators from 'utils/validators';
import {isReader} from 'utils/permissions';

class ProfileForm extends React.Component {
  render() {
    const {avatarOptions, handleSubmit, pristine, submitting} = this.props;
    return (
      <Form className="profile-form" onSubmit={handleSubmit}>
        <Row>
          <Col md={12}>
            <Field
              name="username"
              label="Username"
              component={fields.Input}
              required
              validate={[validators.isRequired, validators.isUsername]}
            />
          </Col>
          <Col md={6}>
            <Field
              name="firstName"
              label="First Name"
              component={fields.Input}
              required
              validate={[validators.isRequired]}
            />
          </Col>
          <Col md={6}>
            <Field
              name="lastName"
              label="Last Name"
              component={fields.Input}
              required
              validate={[validators.isRequired]}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Field
              name="password"
              label="Password"
              component={fields.Input}
              required
              type="password"
              validate={[validators.isRequired]}
            />
          </Col>
          <Col md={6}>
            <Field
              name="confirmPassword"
              label="Confirm Password"
              component={fields.Input}
              required
              type="password"
              validate={[validators.isRequired, validators.isConfirmPasswordMatch]}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {!isEmpty(avatarOptions) ? (
              <Field
                name="avatar"
                label="Avatar"
                clickableKey="image"
                valueKey="value"
                options={avatarOptions}
                component={fields.ClickSelectField}
                hasSelectedEffect
                hasOverlay={false}
              />
            ) : (
              <Field id="avatar" name="avatar" label="Select Avatar" component={fields.FileField} />
            )}
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Button type="submit" variant="contained" color="primary" fullWidth disabled={pristine || submitting}>
              Submit
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}

const mapStateToProps = (state, {activeUserAvatars}) => {
  const {account} = state;
  const user = account.get('user').toJS();
  const {username, firstName, lastName, role, avatar} = user;
  return {
    role,
    avatarOptions: getReaderAvatarOptions(activeUserAvatars),
    initialValues: {
      username,
      firstName,
      lastName,
      avatar: isReader(role) ? avatar : null,
    },
  };
};

export default makeForm(ProfileForm, 'ProfileForm', mapStateToProps, null);
